import React from 'react';
import { Column } from 'components';
import { useProduct } from '../hooks/useProduct';
import { useProductPrice } from '../hooks/useProductPrice';
import { PDPForm } from './Form';
import { getGatsbySiteUrl } from 'helpers/env';
import { Wrapper } from './styled';
import { Rating } from 'types/Product';
import { PdpImageGallery } from 'components/PdpImageGallery';
import { useStickyBox } from 'react-sticky-box';
import { PdpAccordion } from './PdpAccordion';
import { useProductUseCase } from '../hooks/useProductUseCase';
import ProductHeader from './ProductHeader';

type PDPProps = {
  rating: Rating;
};

// TODO: Once the split is at 100% we will handle this in a more data-driven way
const productsToRetainTopDetails = ['curation-services'];
export const pdpTopException = (sku: string): boolean => productsToRetainTopDetails.includes(sku);

export const PDP = ({ rating }: PDPProps): JSX.Element => {
  const { product } = useProduct();
  const price = useProductPrice();
  const useCaseValues = useProductUseCase();

  const stickyBoxRef = useStickyBox();

  const hasNoRating = rating === undefined;
  const hasSmallRatingCountAndLowScore = rating?.totalReviews < 5 && rating?.score < 4;
  const shouldHideRating = hasNoRating || hasSmallRatingCountAndLowScore;

  return (
    <div className="PdpApp">
      <Wrapper>
        <Column size={12} medium={6} className="z-pt-tiny photo-slider-column">
          <PdpImageGallery />
        </Column>
        <Column size={12} medium={6}>
          <div ref={stickyBoxRef}>
            <ProductHeader
              productTitle={useCaseValues.title}
              price={price}
              product={product}
              siteUrl={getGatsbySiteUrl() || ''}
              rating={!shouldHideRating && rating}
            />
            <PDPForm displayNewPdpTop />
            <PdpAccordion />
          </div>
        </Column>
      </Wrapper>
    </div>
  );
};
